import type { BreadcrumbType } from '@bugsnag/js';

const DEFAULT_BREADCRUMB_TYPES: BreadcrumbType[] = [
	'navigation',
	'request',
	'process',
	'user',
	'state',
	'error',
	'manual',
];

/**
 * Returns the shared default BugSnag breadcrumb types. Kiosk excludes user
 * interactions because browser click breadcrumbs contain keyboard key text.
 *
 * Console log breadcrumbs are deliberately excluded because their free-form
 * messages and serialized arguments cannot be reliably redacted.
 */
export default function getBugsnagBreadcrumbTypes(): BreadcrumbType[] {
	return [...DEFAULT_BREADCRUMB_TYPES];
}
